import { observer } from "mobx-react-lite";
import { useEffect, useRef, useState } from "react";
import styles from "./styles.module.css";
import { ReactComponent as BackArrowSvg } from "../../../../../assets/backarrow.svg";
import { Button, Form, Label } from "semantic-ui-react";
import { useNavigate, useParams } from "react-router-dom";
import { ErrorMessage, Field, Formik } from "formik";
import { vendorSchema } from "../../../../../app/validation/validationSchema";
import { SelectTemp } from "../../../../../app/common/form/Custom";
import { ReturnLocationUpdateForm } from "../../../../../app/models/shipping";
import { useStore } from "../../../../../app/stores/store";
import Loading from "../../../../../app/layout/Loading";
import { ReactComponent as ThumbsUpSvg } from "../../../../../assets/navbericon/thumbsup.svg";
import Modal from "../../../../../app/common/modals/Custom";
import responseCodes from "../../../../../app/common/hooks/helpers";
import { toast } from "react-toastify";
import { validate as uuidValidate } from "uuid";
import {
  selectStateOptions,
  stateOptions,
} from "../../../../../app/common/options/categoryOptions";

const UpdateReturnLocation = () => {
  const navigate = useNavigate();
  const params = useParams();
  const returnLocationId = params.id!;
  const { shippingStore } = useStore();
  const {
    loadingInitial,
    updateReturnLocation,
    fetchReturnLocationAsync,
    guidStatus,
    setGuidStatus,
    currentReturnLocation,
  } = shippingStore;
  const [modal, setModal] = useState("");
  const [inputField, setInputField] = useState(new ReturnLocationUpdateForm());

  const saveForm = async (values: any) => {
    await updateReturnLocation(values).then((res) => {
      if (res?.responseCode === responseCodes.response_00) {
        toast.info(res.responseMessage);
        setModal("success");
      }
    });
  };

  var initialValues = {
    ...inputField,
    returnProductLocationId: currentReturnLocation
      ? currentReturnLocation.returnProductLocationId
      : "",
    address: currentReturnLocation ? currentReturnLocation.address : "",
    city: currentReturnLocation ? currentReturnLocation.city : "",
    state: currentReturnLocation ? currentReturnLocation.state : "",
  };
  const count = useRef(0);
  useEffect(() => {
    if (uuidValidate(returnLocationId)) {
      if (guidStatus !== "loading" && count.current === 0) {
        count.current = count.current + 1;
        fetchReturnLocationAsync(returnLocationId).finally(() =>
          setGuidStatus("")
        );
      }
    } else {
      navigate("/vendor/shipping/returnlocationlist");
    }
  }, []);
  return (
    <div className={styles.locationWrapper}>
      {(guidStatus === "loading" || loadingInitial === "loading") && (
        <Loading />
      )}
      {modal === "success" && (
        <Modal
          variant="unstyled"
          style={{ position: "fixed", zIndex: "2" }}
          openModal={true}
          closeModal={() => setModal("")}
        >
          <div className={styles.verifyAccountModal}>
            <div className={styles.info}>
              {" "}
              <ThumbsUpSvg />
            </div>
            <div className={styles.welcomeText}>
              <p>Return Location Updated Successfully</p>
            </div>

            <div className={styles.twoButton}>
              <Button
                positive
                className={styles.modalactivate}
                onClick={() => navigate(-1)}
              >
                <div className={styles.button}>
                  <span>Okay!</span>
                </div>
              </Button>
            </div>
          </div>
        </Modal>
      )}{" "}
      <div className={styles.header}>
        <div className={styles.back}>
          <BackArrowSvg onClick={() => navigate(-1)} />
          <span>Go back</span>
        </div>
      </div>
      <div className={styles.headerTitle}>Update Return Location</div>
      <Formik
        initialValues={initialValues}
        enableReinitialize
        onSubmit={saveForm}
        validationSchema={vendorSchema.locationInfoUpdate}
      >
        {({
          dirty,
          errors,
          getFieldProps,
          handleSubmit,
          values,
          setFieldValue,
          setValues,
          isValid,
          isSubmitting,
        }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <div className={styles.shippingAddressWrapper}>
                <div className={styles.shippingAddress}>
                  <div className={styles.shippingAddressInfo}>
                    <div className={styles.name}>Address</div>
                    <div className={styles.contact}>
                      <div className={styles.mail}>
                        <div className={styles.lone}>
                          <Field
                            placeholder="Enter address here ..."
                            name={`address`}
                            style={{ height: 48 }}
                            onChange={(e: any) => {
                              setFieldValue(`address`, e.target.value);
                            }}
                          />
                          <ErrorMessage
                            name={`address`}
                            render={(error) => (
                              <Label basic color="red" content={error} />
                            )}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={styles.shippingAddressInfo}>
                    <div className={styles.name}>City</div>
                    <div className={styles.contact}>
                      <div className={styles.mail}>
                        <div className={styles.lone}>
                          <Field
                            placeholder="Enter city here ..."
                            name={`city`}
                            style={{ height: 48 }}
                            onChange={(e: any) => {
                              setFieldValue(`city`, e.target.value);
                            }}
                          />
                          <ErrorMessage
                            name={`city`}
                            render={(error) => (
                              <Label basic color="red" content={error} />
                            )}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={styles.shippingAddressInfo}>
                    <div className={styles.name}>State</div>
                    <div className={styles.contact}>
                      <div className={styles.mail}>
                        <div className={styles.lone}>
                          <SelectTemp
                            inputType="text"
                            labelStyle={{ margin: 0 }}
                            placeholder={
                              stateOptions &&
                              stateOptions[
                                stateOptions.findIndex(
                                  (x) => (x.value = values.state)
                                )
                              ] &&
                              stateOptions[
                                stateOptions.findIndex(
                                  (x) => (x.value = values.state)
                                )
                              ].value
                            }
                            options={selectStateOptions
                              .sort(function (x, y) {
                                let a = x.value.toUpperCase(),
                                  b = y.value.toUpperCase();
                                return a === b ? 0 : a > b ? 1 : -1;
                              })
                              .map((state, index) => ({
                                key: index,
                                label: state.value,
                                value: state.value,
                              }))}
                            value={values.state}
                            onValueChange={(e: any) => {
                              setFieldValue("state", e.value);
                            }}
                            name={"state"}
                          />
                          <ErrorMessage
                            name={"state"}
                            render={(error) => (
                              <Label basic color="red" content={error} />
                            )}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.footer}>
                <div className={styles.searchAndFilter}>
                  <Button
                    positive
                    className={styles.bulkProduct}
                    type="submit"
                    disabled={!isValid}
                  >
                    <div className={styles.positive}>
                      <span>Save</span>
                    </div>
                  </Button>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default observer(UpdateReturnLocation);
